import { render, staticRenderFns } from "./HIVEstimation.vue?vue&type=template&id=7f1d1d60&scoped=true&"
import script from "./HIVEstimation.vue?vue&type=script&lang=js&"
export * from "./HIVEstimation.vue?vue&type=script&lang=js&"
import style0 from "./HIVEstimation.vue?vue&type=style&index=0&id=7f1d1d60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d1d60",
  null
  
)

export default component.exports